import RightContainer from './RightContainer';

export default RightContainer;
